function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_986_15067)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M145.77 20.86H141.09V3.86001H145.77C151.03 3.86001 155.32 6.98001 155.32 12.43C155.52 17.54 151.23 20.86 145.77 20.86ZM145.97 0.0100098H137.59V24.56H145.97C153.37 24.56 159.22 19.69 159.22 12.28C159.22 4.87001 153.18 0.0100098 145.97 0.0100098Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.809985 24.56H4.50999C4.5047 23.177 4.77319 21.8067 5.3 20.5279C5.82681 19.2492 6.6015 18.0874 7.57943 17.1094C8.55736 16.1315 9.71917 15.3568 10.9979 14.83C12.2766 14.3032 13.647 14.0347 15.03 14.04H16.03V10.34H15.03C13.0478 10.3478 11.0889 10.7679 9.27777 11.5736C7.46668 12.3793 5.84301 13.5529 4.50999 15.02V3.9H17.51V0H0.609985L0.809985 24.56Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.41 0.0100098H19.71V24.56H34.71V20.86H23.41V0.0100098Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.61 12.67C53.6221 13.724 53.4234 14.7697 53.0256 15.7457C52.6278 16.7218 52.039 17.6085 51.2937 18.3538C50.5485 19.0991 49.6617 19.6879 48.6857 20.0856C47.7096 20.4834 46.6639 20.6821 45.61 20.67C44.5561 20.6821 43.5104 20.4834 42.5343 20.0856C41.5583 19.6879 40.6716 19.0991 39.9263 18.3538C39.181 17.6085 38.5922 16.7218 38.1944 15.7457C37.7966 14.7697 37.5979 13.724 37.61 12.67V11.89C37.5979 10.8361 37.7966 9.79042 38.1944 8.81436C38.5922 7.83831 39.181 6.95159 39.9263 6.20631C40.6716 5.46102 41.5583 4.8722 42.5343 4.47443C43.5104 4.07667 44.5561 3.87798 45.61 3.89004C46.6639 3.87798 47.7096 4.07667 48.6857 4.47443C49.6617 4.8722 50.5485 5.46102 51.2937 6.20631C52.039 6.95159 52.6278 7.83831 53.0256 8.81436C53.4234 9.79042 53.6221 10.8361 53.61 11.89V12.67ZM45.61 0.0100411C44.0468 0.00207853 42.4976 0.304254 41.052 0.899087C39.6064 1.49392 38.2932 2.36959 37.1883 3.4754C36.0834 4.58121 35.2088 5.8952 34.6152 7.34129C34.0216 8.78739 33.7207 10.3369 33.73 11.9V12.68C33.7207 14.2441 34.0219 15.7944 34.6162 17.2411C35.2104 18.6879 36.0859 20.0023 37.1918 21.1082C38.2977 22.2142 39.6122 23.0896 41.0589 23.6839C42.5057 24.2781 44.056 24.5793 45.62 24.57C47.184 24.5793 48.7343 24.2781 50.1811 23.6839C51.6278 23.0896 52.9423 22.2142 54.0482 21.1082C55.1542 20.0023 56.0296 18.6879 56.6239 17.2411C57.2181 15.7944 57.5193 14.2441 57.51 12.68V11.9C57.466 8.7603 56.1992 5.7615 53.9789 3.54115C51.7585 1.3208 48.7597 0.0539961 45.62 0.0100411H45.61Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.97 0.0100098L74.85 7.22001L76.85 11.9L81.92 0.0100098H77.97Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.32 0.0100098L79.91 19.3L76.79 11.9L74.79 7.22001L71.72 0.0100098H67.63L72.7 11.9L69.58 19.3L61.21 0.0100098H57.12L67.64 24.56H71.32L74.65 16.75L77.96 24.54H81.66L92.19 0.0100098H88.32Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.32 13.65C99.5245 13.7003 97.7487 14.038 96.06 14.65L100.15 5.30001L103.66 13.68L101.32 13.65ZM98.43 0.0100098L89.32 21.05C89.13 21.44 88.93 22.05 88.74 22.41L87.96 24.41H92.05L93.22 21.88C94.0871 20.4366 95.3168 19.2452 96.7869 18.4242C98.257 17.6032 99.9163 17.1812 101.6 17.2H105.5L108.62 24.41H112.71L102.13 0.0100098H98.43Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.51 13.84H119.32V3.90001H125.56C126.897 3.92314 128.174 4.46472 129.119 5.41057C130.065 6.35641 130.607 7.63258 130.63 8.97001C130.596 10.2945 130.038 11.5513 129.078 12.4644C128.118 13.3775 126.834 13.8722 125.51 13.84ZM134.32 8.97001C134.324 7.8172 134.1 6.675 133.66 5.60919C133.221 4.54338 132.575 3.575 131.76 2.75984C130.945 1.94468 129.977 1.29884 128.911 0.859511C127.845 0.420181 126.703 0.196039 125.55 0.200003H115.61V24.75H119.32V17.93H124.78C125.17 18.51 127.7 22.61 129.26 24.75H133.74C133.54 24.56 133.35 24.36 133.35 24.17L128.87 17.17C130.442 16.4333 131.782 15.279 132.743 13.833C133.704 12.387 134.25 10.7048 134.32 8.97001Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M78.0413 36L82.4086 44.2302L92.0825 45.5946L85.0854 51.9763L86.729 61.0427L78.0413 56.7736L69.3535 61.0427L70.9971 51.9763L64 45.5946L73.7209 44.2302L78.0413 36Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M78.1368 49.6437L82.4572 44.2302L78.1368 36V49.6437Z",
  fill: "url(#paint0_linear_986_15067)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M77.948 36L73.6277 44.2302L77.948 49.6437V36Z",
  fill: "url(#paint1_linear_986_15067)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M77.901 49.6871L73.7684 44.1416L64.0475 45.462L77.901 49.6871Z",
  fill: "url(#paint2_linear_986_15067)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M64 45.6396L70.9972 52.0214L77.8535 49.8648L64 45.6396Z",
  fill: "url(#paint3_linear_986_15067)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M77.9026 49.9084L70.9994 51.889L69.3088 60.9554L77.9026 49.9084Z",
  fill: "url(#paint4_linear_986_15067)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M69.447 61.0434L78.1347 56.7743L78.0408 49.9965L69.447 61.0434Z",
  fill: "url(#paint5_linear_986_15067)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M78.0897 49.9965L77.9488 56.7743L86.6366 61.0434L78.0897 49.9965Z",
  fill: "url(#paint6_linear_986_15067)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M86.7776 60.9554L85.134 51.889L78.2307 49.9084L86.7776 60.9554Z",
  fill: "url(#paint7_linear_986_15067)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M78.2307 49.8208L85.087 52.0214L92.0842 45.6396L78.2307 49.8208Z",
  fill: "url(#paint8_linear_986_15067)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M92.0372 45.462L82.3633 44.1416L78.1838 49.6871L92.0372 45.462Z",
  fill: "url(#paint9_linear_986_15067)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M8.41733 60L0 36H5.36133L11.527 54.4734L17.6387 36H23L14.5293 60H8.41733Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M26 36H31V60H26V36Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M45.3821 36.002C46.5166 35.978 47.6449 36.1693 48.7004 36.5647C49.756 36.9601 50.7177 37.5516 51.5291 38.3046C53.1132 39.8436 54 41.9097 54 44.061C54 46.2124 53.1132 48.2785 51.5291 49.8175C50.7177 50.5705 49.756 51.162 48.7004 51.5574C47.6449 51.9528 46.5166 52.1441 45.3821 52.1201H40.9066V60H36V36.002H45.3821ZM45.3821 47.7196C45.8775 47.7279 46.3691 47.6364 46.8246 47.4512C47.28 47.266 47.6888 46.9912 48.0241 46.6451C48.3699 46.297 48.6387 45.8868 48.8146 45.4386C48.9906 44.9904 49.0701 44.5133 49.0486 44.0355C49.0801 43.0719 48.7123 42.135 48.0241 41.4259C47.6782 41.0964 47.2662 40.836 46.8124 40.6603C46.3586 40.4845 45.8722 40.3968 45.3821 40.4025H40.9066V47.7196H45.3821Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_986_15067",
  x1: 78.1368,
  y1: 42.8218,
  x2: 82.4572,
  y2: 42.8218,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDFFF3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#FCF7DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#F8E3A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F3C34E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1B932"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_986_15067",
  x1: 75.7878,
  y1: 49.6877,
  x2: 75.7878,
  y2: 36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#5F3618"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#DCA24E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#E5C466"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#EBDC77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#EDE57D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_986_15067",
  x1: 70.9977,
  y1: 47.6185,
  x2: 72.1657,
  y2: 43.7017,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDE579"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#EBD672"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#E6B964"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#E2B561"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#D8A959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#C6954B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#AD7937"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A57031"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_986_15067",
  x1: 72.359,
  y1: 51.6253,
  x2: 69.8103,
  y2: 43.6897,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#B9873C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_986_15067",
  x1: 74.8502,
  y1: 56.8623,
  x2: 71.0833,
  y2: 51.8266,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_986_15067",
  x1: 79.2618,
  y1: 54.0455,
  x2: 68.3398,
  y2: 57.3681,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_986_15067",
  x1: 484.449,
  y1: 123.901,
  x2: 476.436,
  y2: 136.604,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_986_15067",
  x1: 81.518,
  y1: 49.4243,
  x2: 84.0412,
  y2: 66.9023,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#AA7534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#DCA24E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_986_15067",
  x1: 84.9461,
  y1: 47.2681,
  x2: 86.5408,
  y2: 51.4771,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_986_15067",
  x1: 90.3936,
  y1: 49.511,
  x2: 80.0144,
  y2: 45.2288,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEAC1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#EFB534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#F3CD6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F9F3C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBFFE1"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_986_15067"
}, /*#__PURE__*/React.createElement("rect", {
  width: 159.22,
  height: 60.67,
  fill: "white"
})));

function SvgVipLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 62,
    viewBox: "0 0 160 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipLogo);
export default __webpack_public_path__ + "static/media/vip-logo.70df9b18.svg";
export { ForwardRef as ReactComponent };